module.exports = __webpack_public_path__ + "img/pn.47a453f3.svg";